import type { PayloadAction } from '@reduxjs/toolkit'

export const createSetter =
	<Slice, K extends keyof Slice = keyof Slice>(key: K) =>
	(state: Slice, { payload }: PayloadAction<Slice[K]>) => {
		state[key] = payload
	}
